module.exports = __webpack_public_path__ + "img/3.744f12b1.png";